module.exports = __webpack_public_path__ + "src/images/dp.61a4ae21de6a0426c6c56076fa208f2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dp.jpg
// module id = 92
// module chunks = 0